<template>
    <div class="event-card__footer" v-if="priceParams">

        <template v-if="isShowDiff">
            <p class="event-card__price-old" v-html="price.PRINT_VALUE"></p>
            <p class="event-card__price" v-html="price.PRINT_DISCOUNT_VALUE"></p>
            <p class="event-card__price" v-html="price.DISCOUNT_DIFF_PERCENT"></p>
            <p class="event-card__price" v-html="price.PRINT_DISCOUNT_DIFF"></p>
        </template>

        <template v-else>
            <div class="event-card__prices">
                <span class="event-card__price" v-html="prices.current"></span>
                <span class="event-card__price-old" v-html="prices.old" v-if="prices.old"></span>
            </div>
        </template>

        <slot></slot>
    </div>
</template>

<script>

/**
 * С бэка передаётся объект price
 *
 * Важны следующие пары ключ-значение:
 *
 * price.PRINT_VALUE {html-string} - цена с уже указанной валютой (есть неразрывный пробел, поэтому вставка через v-html)
 * price.PRINT_DISCOUNT_VALUE {html-string} - цена со скидкой и указанием валюты (есть неразрывный пробел, поэтому вставка через v-html)
 * price.DISCOUNT_DIFF_PERCENT {number} - размер скидки (если ноль, выводим price.PRINT_VALUE)
 * price.PRINT_DISCOUNT_DIFF {html-string} - разница в цене
 *
 * В слоте выводится ссылка
 *
 */

export default {
    name: 'event-card-footer',

    props: {
        price: {
            type: Object || null,
        },
    },

    computed: {
        isShowDiff() {
            return this.price?.DISCOUNT_DIFF_PERCENT;
        },

        priceParams() {
            return this.price || null;
        },

        prices() {
            return {
                current: this.price?.PRINT_DISCOUNT_VALUE,
                old: this.price?.PRINT_VALUE !== this.price?.PRINT_DISCOUNT_VALUE ? this.price?.PRINT_VALUE : null,
            };
        },
    },
};
</script>
